export default "__VITE_ASSET__1373e0b7__"